import { OfferTypeChecker } from '../../../common/utils/offer-type-util';
import { PaymentOrderDetails } from '../order-completion.interface';

/**
 * Verifies if the order in the confirmation page is an HE custom store order (Create).
 *
 * @param order
 */
export function isHeCustomStorePaymentOrder(order?: PaymentOrderDetails): boolean {
  return (
    order?.orderItems?.some(
      (p) => p.productClassifier === 'CUSTOM' || OfferTypeChecker.isCreateEbook(p.productMetaData?.offerType)
    ) || false
  );
}

/**
 * Verifies if the order in the confirmation page is an HE private store order (Custom).
 *
 * @param order
 */
export function isHePrivateStorePaymentOrder(order?: PaymentOrderDetails): boolean {
  return (
    order?.orderItems?.some(
      (p) => p.productClassifier === 'PRIVATE' || OfferTypeChecker.isCustom(p.productMetaData?.offerType)
    ) || false
  );
}
